export function IconSTCCardMobile() {
  return (
    <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.208984" width="54" height="54" rx="6" fill="white" fillOpacity="0.2" />
      <circle cx="38.6875" cy="26.5215" r="7.3125" fill="white" />
      <circle cx="27.3125" cy="26.5215" r="7.3125" fill="white" fillOpacity="0.5" />
    </svg>
  )
}
